import { buildI18n } from "go-core/utils/i18nUtils";

const version = "1.0.0";
const cdnUrlTranslation = null;
// "https://delivery.localazy.com/_a78811627961622486549c614f77/_e0/b8e0901515a466a466c5bd9eff3fe77a41900610";
const cdns = {
	translation: cdnUrlTranslation,
};
let i18n = buildI18n(version, cdns, undefined, false, ["pl", "en"]);
export default i18n;
